import React, { useState } from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  Grid,
  Collapse,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { format } from 'date-fns';

function filterNonNullValues(connectionStatus) {
  return Object.fromEntries(
    Object.entries(connectionStatus).filter(([key, value]) => value !== null),
  );
}

const groupConnectionStatus = (connectionStatus) => {
  const groupedStatus = {};

  Object.entries(connectionStatus).forEach(([key, value]) => {
    const group = key.match(
      /^Latest([A-Za-z]+?)(Timestamp|SignalLevel|Imei|Workmode|DeviceName|IpAddress|MacAddress|Ssid|Channel|Frequency|Imsi|Apn|Rssi|Rsrq|Rsrp|Cinr)$/,
    );

    if (group) {
      const prefix = group[1];
      if (!groupedStatus[prefix]) {
        groupedStatus[prefix] = {};
      }
      groupedStatus[prefix][key] = value;
    }
  });

  return groupedStatus;
};

const formatValue = (key, value) => {
  if (key.toLowerCase().includes('timestamp')) {
    return format(new Date(value), 'yyyy-MM-dd HH:mm:ss');
  }
  return value.toString();
};

const GatewayDetailDrawer = ({ gateway, open, onClose }) => {
  const filteredConnectionStatus = gateway?.ConnectionStatus
    ? filterNonNullValues(gateway.ConnectionStatus)
    : {};
  const groupedStatus = groupConnectionStatus(filteredConnectionStatus);
  const [openSections, setOpenSections] = useState({});

  const handleToggle = (section) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Stack
        direction={'column'}
        // sx={{
        //   display: 'flex',
        //   flexDirection: 'column',
        //   overflow: 'auto',
        //   padding: 3,
        //   width: '100%', // Ensures the Stack takes up the full width of the Drawer
        //   minWidth: 600,
        //   maxWidth: 1000, // Limits the width of the Drawer
        //   height: '100%', // Ensures the Stack takes up the full height of the Drawer
        //   // backgroundColor: 'background.default',
        // }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            mb: 2,
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
            {gateway?.Name}
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{ position: 'absolute', right: 0, borderRadius: 1, ml: 1 }}
          >
            <CloseIcon sx={{ color: 'gray' }} />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="body1" fontSize="0.9rem" fontWeight="bold">
                Gateway ID
              </Typography>
              <Typography variant="body1" fontSize="0.9rem">
                {gateway?.GatewayId}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" fontSize="0.9rem">
                Status
              </Typography>
              <Typography
                variant="body1"
                fontSize="0.9rem"
                sx={{ color: gateway?.Online ? 'success.main' : 'error.main' }}
              >
                {gateway?.Online ? 'Online' : 'Offline'}
              </Typography>
            </Box>
          </Grid>
          {Object.entries(groupedStatus).map(([prefix, details]) => (
            <Grid item xs={12} key={prefix}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => handleToggle(prefix)}
              >
                <Typography variant="body1" fontWeight="bold" fontSize="0.9rem">
                  {prefix} Connection Status
                </Typography>
                {openSections[prefix] ? (
                  <ExpandLessIcon
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === 'light'
                          ? 'hsl(0, 0%, 20%)'
                          : 'hsl(0, 0%, 85%)',
                    }}
                  />
                ) : (
                  <ExpandMoreIcon
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === 'light'
                          ? 'hsl(0, 0%, 20%)'
                          : 'hsl(0, 0%, 85%)',
                    }}
                  />
                )}
              </Box>
              <Collapse in={openSections[prefix]}>
                <List component="div" disablePadding>
                  {Object.entries(details).map(([key, value]) => (
                    <ListItem key={key}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Typography
                              variant="body1"
                              fontWeight="bold"
                              fontSize="0.9rem"
                            >
                              {key.replace(/([A-Z])/g, ' $1').trim()}
                            </Typography>
                            <Typography variant="body1" fontSize="0.9rem">
                              {formatValue(key, value)}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Drawer>
  );
};

export default GatewayDetailDrawer;
